import { AxiosResponse } from 'axios';
import { snakeCaseKeys } from 'helpers/utils';
import { get, post, remove } from 'services/api';
import { IMatzevaFormData } from 'views/public/MatzevaView/components/MatzevaForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `matzeva?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('matzeva/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`matzeva/${id}`);

export const save = (data: IMatzevaFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append(
    'person',
    JSON.stringify(snakeCaseKeys(data.person as unknown as Record<string, unknown>)),
  );
  formData.append(
    'cementery',
    JSON.stringify(snakeCaseKeys(data.cementery as unknown as Record<string, unknown>)),
  );
  if (data.cementery.sketchFile)
    formData.append('cementery_sketch_file', data.cementery.sketchFile);
  if (data.cementery.spanishFile)
    formData.append('cementery_spanish_file', data.cementery.spanishFile);
  if (data.cementery.hebrewFile)
    formData.append('cementery_hebrew_file', data.cementery.hebrewFile);
  formData.append(
    'details',
    JSON.stringify(snakeCaseKeys(data.details as unknown as Record<string, unknown>)),
  );
  if (data.details.matzevaFile) formData.append('details_matzeva_file', data.details.matzevaFile);
  formData.append('applicant_name', data.applicantName);
  if (data.comments) formData.append('comments', data.comments);
  if (id) formData.append('_method', 'PUT');
  return post(`matzeva${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`matzeva/${id}`);
